import React from 'react';
import { Sector } from 'recharts';
import { InsightsTimeOptions } from 'src/graphql';

export const updateYear = (
  e: React.MouseEvent,
  year: number,
  setIsInUse: (inUse: InsightsTimeOptions) => void,
  setOpen: (open: boolean) => void,
  setCurrentYear: (currentYear: number | undefined) => void,
) => {
  e.stopPropagation();

  setIsInUse(InsightsTimeOptions.Year);
  setOpen(false);
  setCurrentYear(year);
};

export const sortTooltips = (item: any): number => {
  switch (item.name) {
    case 'Mobile App Reporting':
      return -1;
    case 'Open Reporting':
      return 1;
    default:
      return 1;
  }
};

export const renderActiveShape = (props: any) => {
  const RADIAN = Math.PI / 180;
  const {
    cx,
    cy,
    midAngle,
    innerRadius,
    outerRadius,
    startAngle,
    endAngle,
    fill,
    payload,
    percent,
    value,
  } = props;
  const sin = Math.sin(-RADIAN * midAngle);
  const cos = Math.cos(-RADIAN * midAngle);
  const sx = cx + (outerRadius + 10) * cos;
  const sy = cy + (outerRadius + 10) * sin;
  const mx = cx + (outerRadius + 30) * cos;
  const my = cy + (outerRadius + 30) * sin;
  const ex = mx + (cos >= 0 ? 1 : -1) * 12;
  const ey = my;
  const textAnchor = cos >= 0 ? 'start' : 'end';

  return (
    <g>
      <text x={cx} y={cy} dy={8} textAnchor="middle" fill={fill}>
        {payload.name}
      </text>
      <Sector
        cx={cx}
        cy={cy}
        innerRadius={innerRadius}
        outerRadius={outerRadius}
        startAngle={startAngle}
        endAngle={endAngle}
        fill={fill}
      />
      <Sector
        cx={cx}
        cy={cy}
        startAngle={startAngle}
        endAngle={endAngle}
        innerRadius={outerRadius + 6}
        outerRadius={outerRadius + 10}
        fill={fill}
      />
      <path
        d={`M${sx},${sy}L${mx},${my}L${ex},${ey}`}
        stroke={fill}
        fill="none"
      />
      <circle cx={ex} cy={ey} r={2} fill={fill} stroke="none" />
      <text
        x={ex + (cos >= 0 ? 1 : -1) * 12}
        y={ey}
        textAnchor={textAnchor}
        fill="#333"
      >{`${payload.name}: ${value}`}</text>
      <text
        x={ex + (cos >= 0 ? 1 : -1) * 12}
        y={ey}
        dy={18}
        textAnchor={textAnchor}
        fill="#999"
      >
        {`(Rate ${(percent * 100).toFixed(2)}%)`}
      </text>
    </g>
  );
};

export const handleClickAll = (
  e: React.MouseEvent,
  setIsInUse: (inUse: InsightsTimeOptions) => void,
  setOpen: (open: boolean) => void,
) => {
  e.stopPropagation();

  setIsInUse(InsightsTimeOptions.All);
  setOpen(false);
};

export const handleClickPastMonth = (
  e: React.MouseEvent,
  setIsInUse: (inUse: InsightsTimeOptions) => void,
  setOpen: (open: boolean) => void,
) => {
  e.stopPropagation();
  setIsInUse(InsightsTimeOptions.Month);
  setOpen(false);
};
